<template>
  <div id="inventoryTags">
    <TipBox info :title="$t('tags.tip_title')">
      {{$t('tags.tip_description')}}
    </TipBox>
    <Datatable
      v-if="inventory"
      entity="inventory_tag"
      class="datatable"
      ref="datatable"
      :parameters="{inventory: inventory.id}"
      :onRowClick="onRowClick"
      :globalActions="[{text: 'tags.new', method: onCreate, condition: function() { return $store.getters.loggedUserHasModifyPermission}}]"
      :rowActions="[
        {text: 'datatable.edit', method: onRowEdit},
        {text: 'datatable.delete', method: onRowDelete, condition: function() { return $store.getters.loggedUserHasModifyPermission}}
      ]">
    </Datatable>
  </div>
</template>

<script>

  import Datatable from "@/components/Datatable.vue";
  import { mapActions } from "vuex";

  export default {

    name: "Tags",

    components: { Datatable },

    data() {
      return {
        inventory: null,
        entityName: 'tags'
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "inventory.tags";
      this.$store.state.pageIcon = "/icon/menu.svg";
      this.inventory = await this.$store.getters.getContextInventory;
    },

    methods: {

      ...mapActions(["deleteInventoryEntity"]),

      edit(id) {
        this.$router.push({ path: '/tags/edit', query : Object.assign({ id : id }, this.$route.query) });
      },
      onCreate() {
        this.edit(null)
      },
      onRowClick(row) {
        this.edit(row.id);
      },
      onRowEdit(row) {
        this.edit(row.id)
      },
      async onRowDelete(row) {
        await this.deleteInventoryEntity({ entity: this.entityName, inventory: this.inventory.id, id: row.id });
        this.$refs.datatable.query();
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>